/**
 * Goober setup for Preact
 * This MUST be imported before any styled components are used
 */

import { css, glob, keyframes, setup, styled } from 'goober'
import { h } from 'preact'
import { baseTextStyles, colors, typography } from './theme'

// Initialize goober with Preact's createElement
setup(h)

// Apply global dyslexia-friendly typography styles
// Target both #ui-root (game UI) and #auth-root (auth flows)
glob`
  /* UI containers - dyslexia-friendly defaults */
  #ui-root,
  #auth-root {
    ${baseTextStyles}
  }

  /* Ensure all UI text inherits proper styles */
  #ui-root *,
  #auth-root * {
    font-family: ${typography.fontFamily};
    letter-spacing: ${typography.letterSpacing};
    word-spacing: ${typography.wordSpacing};
  }

  /* Links */
  #ui-root a,
  #auth-root a {
    color: ${colors.accentPrimary};
    text-decoration: underline;
    text-underline-offset: 3px;
  }

  #ui-root a:hover,
  #auth-root a:hover {
    color: ${colors.accentHover};
  }

  /* Focus styles for keyboard navigation */
  #ui-root *:focus-visible,
  #auth-root *:focus-visible {
    outline: 2px solid ${colors.accentPrimary};
    outline-offset: 2px;
  }
`

// Re-export goober utilities for convenience
export { styled, css, keyframes, glob }
